import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " arrow_back ", -1)
const _hoisted_3 = { class: "mx-4 mt-2" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.allowGoBack)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
            outline: true,
            variant: 'icon',
            tooltip: _ctx.$t('misc.back')
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["tooltip"]))
        : _createCommentVNode("", true),
      _createElementVNode("h3", {
        class: _normalizeClass([{ 'ml-3': !_ctx.allowGoBack }, "mb-0"])
      }, _toDisplayString(_ctx.article.title), 3)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        innerHTML: _ctx.article.content
      }, null, 8, _hoisted_4)
    ])
  ]))
}